<h1 class="main-title">Menú principal</h1>

<div class="menu-container">
  <mat-card class="menu-card" *ngIf="authService.rol === 'admin'">
    <mat-card-header>
      <mat-icon class="menu-icon">add_road</mat-icon>
      <mat-card-title>Rutas</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>
        Administrá las rutas disponibles en el sistema. Podés visualizar, crear
        y modificar rutas de manera simple.
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button routerLink="/rutas" class="btn-redirection">
        Ir a Rutas
      </button>
    </mat-card-actions>
  </mat-card>

  <mat-card class="menu-card">
    <mat-card-header>
      <mat-icon class="menu-icon">assignment</mat-icon>
      <mat-card-title>Solicitudes</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>
        Visualizá y administrá las diferentes solicitudes. Ideal para segmentar
        y organizar la información.
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button routerLink="/solicitudes" class="btn-redirection">
        Ir a Solicitudes
      </button>
    </mat-card-actions>
  </mat-card>

  <mat-card class="menu-card">
    <mat-card-header>
      <mat-icon class="menu-icon">directions_car</mat-icon>
      <mat-card-title>Viajes</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>
        Visualizá y administrá los diferentes viajes. Ideal para segmentar y
        organizar la información.
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button routerLink="/viajes" class="btn-redirection">
        Ir a Viajes
      </button>
    </mat-card-actions>
  </mat-card>

  <mat-card class="menu-card">
    <mat-card-header>
      <mat-icon class="menu-icon">tune</mat-icon>
      <mat-card-title>Parámetros</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>Visualizá y administrá los diferentes parámetros del sistema.</p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button routerLink="/parametros" class="btn-redirection">
        Ir a Parámetros
      </button>
    </mat-card-actions>
  </mat-card>
</div>
